import { render, staticRenderFns } from "./manage_organization_button.vue.js?vue&type=template&id=31f79f9d&vue3!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./manage_organization_button.vue?vue&type=template&id=31f79f9d&vue3"
import script from "./manage_organization_button.vue.js?vue&type=script&lang=js&vue3!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./manage_organization_button.vue?vue&type=script&lang=js&vue3"
export * from "./manage_organization_button.vue.js?vue&type=script&lang=js&vue3!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./manage_organization_button.vue?vue&type=script&lang=js&vue3"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports